import PropTypes from 'prop-types';
import { ConeStriped } from 'react-bootstrap-icons';
import { FormattedMessage } from 'react-intl';
import { Message } from './Message';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ServiceUnavailableMessage(_ref) {
  var onClose = _ref.onClose,
      serverMessage = _ref.serverMessage;
  return /*#__PURE__*/_jsxs(Message, {
    variant: "warning",
    icon: ConeStriped,
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      id: "message.service_unavailable"
    }), !!serverMessage && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
        id: "message.service_unavailable_reason",
        values: {
          b: function b(reason) {
            return /*#__PURE__*/_jsx("strong", {
              children: reason
            });
          },
          reason: serverMessage
        }
      })]
    })]
  });
}
ServiceUnavailableMessage.propTypes = {
  onClose: PropTypes.func.isRequired,
  serverMessage: PropTypes.string
};
ServiceUnavailableMessage.defaultProps = {
  serverMessage: null
};